import { Alert, Button, Flex, Form, Input } from "antd";
import { useTranslation } from "react-i18next";

import { NewPasswordFields } from "../shared/NewPasswordFields";

interface Props {
  error: string;
  onResendCode: () => void;
  onSubmit: (values: { code: string; newPassword: string }) => void;
  username: string;
}

export const ForgotPasswordConfirmForm = ({
  username,
  error,
  onSubmit,
  onResendCode,
}: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <Form<{ code: string; newPassword: string; confirmPassword: string }>
      onFinish={onSubmit}
      layout="vertical"
    >
      <Flex vertical gap="middle">
        {error && <Alert type="error" title={error} showIcon />}

        <Alert
          type="info"
          title={t("passwordLogin.forgotPassword.codeSent", {
            email: username,
          })}
          showIcon
        />

        <Form.Item
          name="code"
          label={t("passwordLogin.forgotPassword.codeLabel")}
          rules={[
            {
              required: true,
              message: t("passwordLogin.forgotPassword.codeRequired"),
            },
          ]}
        >
          <Input size="large" autoComplete="one-time-code" />
        </Form.Item>

        <NewPasswordFields />

        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large">
            {t("passwordLogin.forgotPassword.resetPassword")}
          </Button>
        </Form.Item>

        <Button type="link" block onClick={onResendCode}>
          {t("passwordLogin.forgotPassword.resendCode")}
        </Button>
      </Flex>
    </Form>
  );
};
